// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c3fa6ea7","952":"3426a30b"}[chunkId] + ".chunk.js";
};